import React from "react";
import "../css/my style.css";



export default function ButtonPrevious() {
    return (
        <button className="previous" style={{display: "flex", flexDirection: "row"}}>&laquo;Previous</button>
    )
}